import React from "react";

export interface TestResult {
  success: boolean;
  message: string;
  data?: any;
  error?: string;
  timestamp: number;
}

interface TestResultItemProps {
  result: TestResult;
}

export const TestResultItem: React.FC<TestResultItemProps> = ({ result }) => {
  return (
    <div
      className={`sdk-test-result-item ${result.success ? "success" : "error"}`}
    >
      <div className="sdk-test-result-content">
        <div className="sdk-test-result-message">
          {result.success ? "✅" : "❌"} {result.message}
        </div>
        {result.error && (
          <div className="sdk-test-result-error">Error: {result.error}</div>
        )}
        {result.data && (
          <details className="sdk-test-result-data">
            <summary>View Data</summary>
            <pre>{JSON.stringify(result.data, null, 2)}</pre>
          </details>
        )}
      </div>
      <div className="sdk-test-result-timestamp">
        {new Date(result.timestamp).toLocaleTimeString()}
      </div>
    </div>
  );
};

